import React from 'react';

export const Logo = () => {
  return(
    <h1>Sketch!<i className="snes-jp-logo is-large ml-2"></i></h1>
  );
}